import styled from "styled-components";

export const Container = styled.div``;

export const PanelContainer = styled.div`
  width: 100%;
  height: 100%;
  max-width: 571px;
  min-height: 232px;

  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  max-width: 85%;
  gap: 16px;

  @media (max-width: 768px) {
    max-width: 100%;
  }
`;

export const ValidateWrap = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1;
  gap: 16px;
`;

export const ValidateBoxCode = styled.div`
  border-top: 1px rgba(0, 0, 0, 0.2) dashed;
  width: 100%;
  margin-top: 20px;
  padding-top: 28px;
`;

export const TextValidateCode = styled.span`
  color: #0006ff;
  font-family: "Mangueira", sans-serif;
  font-size: 16px;
  font-weight: 400;
  line-height: 200%;
`;

export const TextWrap = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
`;

export const TextCount = styled.span`
  color: #42474a;
  text-align: center;
  font-family: "Mangueira", sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 200%;
`;

export const TextWait = styled.span`
  color: #42474a;
  font-family: "Mangueira", sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 200%;
`;

export const LinkResendEmail = styled.span`
  color: #00f;
  font-family: "Mangueira", sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 200%;
  text-decoration-line: underline;
`;

export const ButtonCodeWrap = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const InputCheckWrap = styled.div`
  width: 100%;
  position: relative;
`;

export const ValidateInputIcon = styled.div`
  position: absolute;
  top: 50%;
  right: -26px;
  transform: translateY(-50%);

  @media (max-width: 768px) {
    top: 1px;
    right: 4px;
    background: rgb(0, 0, 255);
    border-radius: 50%;

    svg {
      color: #ffffff !important;
    }
  }
`;
